import React from 'react';

import './styles.css';

import TrainingsCard from './TrainingsCard';


export default function TrainingsGroup(props) {
    return (
        <li className='trainings-group'>
            <h3>Treinos <b>{props.dataRef ? props.dataRef : 'sem referêcia'}</b></h3>
            <hr />
            {
                props.trainingsData.length ?
                    <ul>
                        {
                            props.trainingsData.map((item, index) =>
                                <TrainingsCard
                                    hideCallListOptions={props.hideCallListOptions}
                                    key={item.id}
                                    id={item.id}
                                    class={item.turma}
                                    type={item.frequencia}
                                    callList={item.lista}
                                    date={item.data}
                                    start_time={item.hora_inicio.slice(0, 5)}
                                    end_time={item.hora_fim.slice(0, 5)}
                                    listOption={item.listOption}
                                    nextCheck={item.nextCheck}
                                    showPopupCallList={props.showPopupCallList}
                                    showPopupNewCallList={props.showPopupNewCallList}
                                    showPopupCheckout={props.showPopupCheckout}
                                />
                            )
                        }
                    </ul>
                    : <p>Não há treinos nessa data</p>
            }
        </li>
    )
}